var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Resourch",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.30784096,5.22450219 L5.30784096,-1.28758277 C5.30784096,-1.70179633 5.64362739,-2.03758277 6.05784096,-2.03758277 C6.47205452,-2.03758277 6.80784096,-1.70179633 6.80784096,-1.28758277 L6.80784096,5.22450219 L13.2490031,5.22450219 C13.6632166,5.22450219 13.9990031,5.56028863 13.9990031,5.97450219 C13.9990031,6.38871575 13.6632166,6.72450219 13.2490031,6.72450219 L6.80784096,6.72450219 L6.80784096,13.2124172 C6.80784096,13.6266308 6.47205452,13.9624172 6.05784096,13.9624172 C5.64362739,13.9624172 5.30784096,13.6266308 5.30784096,13.2124172 L5.30784096,6.72450219 L-1.25099693,6.72450219 C-1.6652105,6.72450219 -2.00099693,6.38871575 -2.00099693,5.97450219 C-2.00099693,5.56028863 -1.6652105,5.22450219 -1.25099693,5.22450219 L5.30784096,5.22450219 Z",
    id: "delete",
    fill: "#6D7A90",
    fillRule: "nonzero",
    transform: "translate(5.999003, 5.962417) rotate(-315.000000) translate(-5.999003, -5.962417) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.4cb398da808ad85e87b4a6cecb9ed6b1.svg";
export { ForwardRef as ReactComponent };